import {
  FaHome,
  FaUser,
  FaFolderOpen,
  FaEnvelopeOpen,
  FaBriefcase,
  FaGraduationCap,
  FaCode,
  FaGithub,
} from "react-icons/fa";
import { FiFileText, FiUser, FiExternalLink } from "react-icons/fi";

import {
  FaLinkedin,
  FaWhatsapp,
  FaDiscord,
  FaEnvelope,
  FaInstagram,
} from "react-icons/fa";

import Theme1 from "./assets/purple.png";
import Theme2 from "./assets/red.png";
import Theme3 from "./assets/blueviolet.png";
import Theme4 from "./assets/blue.png";
import Theme5 from "./assets/goldenrod.png";
import Theme6 from "./assets/magenta.png";
import Theme7 from "./assets/yellowgreen.png";
import Theme8 from "./assets/orange.png";
import Theme9 from "./assets/green.png";
import Theme10 from "./assets/yellow.png";

import gcorp from "../src/assets/gcorp.png";
import track from "../src/assets/track.png";
import cashuppos from "../src/assets/cashuppos.png";

import patrix from "../src/assets/patrix.png";

export const links = [
  {
    id: 1,
    name: "Início",
    icon: <FaHome className="nav__icon" />,
    path: "/",
  },

  {
    id: 2,
    name: "Sobre",
    icon: <FaUser className="nav__icon" />,
    path: "/sobre",
  },

  {
    id: 3,
    name: "Projetos",
    icon: <FaFolderOpen className="nav__icon" />,
    path: "/projetos",
  },

  {
    id: 4,
    name: "Contato",
    icon: <FaEnvelopeOpen className="nav__icon" />,
    path: "/contato",
  },
];

export const personalInfo = [
  {
    id: 1,
    title: "Nome: ",
    description: "Agostinho Dalte Baptista Soberano",
  },

  {
    id: 3,
    title: "Idade: ",
    description: " 24 anos",
  },

  {
    id: 4,
    title: "Nacionalidade: ",
    description: "Moçambicano",
  },

  {
    id: 5,
    title: "Freelance: ",
    description: "Disponível",
  },

  {
    id: 6,
    title: "Endereço: ",
    description: "Nampula - Moçambique",
  },

  {
    id: 8,
    title: "Email : ",
    description: "soberanoagostinho@gmail.com",
  },

  {
    id: 10,
    title: "Idiomas: ",
    description: "Português, Inglês",
  },
];

export const stats = [
  {
    id: 1,
    no: "15+",
    title: "Certificados de curso <br />na Área",
  },

  {
    id: 2,
    no: "10+",
    title: "Projetos <br /> Finalizados",
  },

  {
    id: 3,
    no: "Lic.",
    title: "Finalista de em <br /> Engenharia Informatica e Telecomunicacaoes ",
  },
  {
    id: 4,
    no: "100%",
    title: "Projetos do <br /> Zero ao Deploy",
  },
];

export const resume = [
  {
    id: 1,
    category: "experience",
    icon: <FaBriefcase />,
    year: "Março 2023 – Presente",
    title: "Co-fundador & Desenvolvedor Full Stack - CODE GENIUS, LDA",
    desc: "Co-fundador da startup tecnológica CODE GENIUS, LDA, com participação ativa na definição da visão estratégica, planeamento e crescimento do negócio. Responsável pelo desenvolvimento completo de sistemas ERP personalizados, plataformas de rastreio GPS e lojas de e-commerce, desde a análise de requisitos até à implementação e manutenção. Atuação no desenvolvimento backend e frontend de aplicações web, integração de bases de dados relacionais, configuração e gestão de servidores VPS, garantindo desempenho, segurança e escalabilidade das soluções. Experiência em trabalho colaborativo com sócios e equipas multidisciplinares, participando em todas as fases dos projetos tecnológicos, desde o planeamento, execução, testes e entrega final ao cliente.",
  },

  {
    id: 2,
    category: "education",
    icon: <FaGraduationCap />,
    year: "Fevereiro 2022 - Fevereiro 2026",
    title:
      "Licenciatura em Engenharia Informática e Telecomunicações – Universidade Politécnica",
    desc: "Ao longo da formação em Engenharia Informática e Telecomunicações, adquiri conhecimentos sólidos em programação, engenharia de software, sistemas de informação, bases de dados, redes de computadores e sistemas de telecomunicações. Desenvolvi competências em análise e modelação de sistemas, programação estruturada e orientada a objetos, desenvolvimento de aplicações, gestão de dados e integração de sistemas. A formação incluiu também conteúdos em arquitetura de computadores, sistemas operativos, comunicações analógicas e digitais, processamento digital de sinais, redes móveis e sistemas de comunicação, permitindo compreender e implementar soluções tecnológicas completas, desde o software até a infraestrutura de rede.",
  },
  {
    id: 3,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2023",
    title: "Foundations of User Experience (UX) Design – Google / Coursera",
    desc: "Certificado emitido pela Google através da plataforma Coursera, com foco nos fundamentos de User Experience (UX) Design. Ao longo do curso, desenvolvi conhecimentos em design centrado no usuário, pesquisa com usuários, definição de problemas, criação de personas, user journeys, wireframes e protótipos. Aprendi a aplicar metodologias de UX para criar produtos digitais funcionais, intuitivos e alinhados às necessidades reais dos usuários, seguindo boas práticas da indústria.",
  },
  {
    id: 4,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "PHP & MySQL – Desenvolvimento Web Backend",
    desc: "Certificação em desenvolvimento web utilizando PHP e MySQL, com foco na criação de aplicações dinâmicas e orientadas a dados. O curso abordou conceitos de programação backend, manipulação de bases de dados relacionais, operações CRUD, autenticação de usuários e integração entre frontend e backend. A formação reforçou a capacidade de desenvolver sistemas web funcionais, seguros e escaláveis, aplicáveis a projetos como ERPs, plataformas web e lojas de e-commerce.",
  },

  {
    id: 5,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Java: Fundamentals – Code With Mosh ",
    desc: "Curso focado nos fundamentos da linguagem Java, cobrindo sintaxe, tipos de dados, estruturas de controlo, métodos, classes e boas práticas de programação. Desenvolveu uma base sólida para a criação de aplicações robustas e escaláveis, com forte ênfase em lógica e estruturação de código.",
  },

  {
    id: 6,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "JavaScript Algorithms and Data Structures – freeCodeCamp",
    desc: "Formação focada no desenvolvimento do raciocínio lógico e resolução de problemas através de algoritmos e estruturas de dados em JavaScript. Abordou temas como arrays, objetos, recursão, estruturas condicionais, loops, estruturas de dados fundamentais e princípios de eficiência, fortalecendo a capacidade de escrever código limpo, performático e escalável.",
  },

  {
    id: 7,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Java: Object-Oriented Programming - Code With Mosh",
    desc: "Formação centrada nos princípios da programação orientada a objetos em Java, incluindo encapsulamento, herança, polimorfismo e abstração. Reforçou a capacidade de desenvolver software modular, reutilizável e de fácil manutenção, aplicável a sistemas complexos.",
  },

  {
    id: 8,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Object-Oriented PHP – The Net Ninja",
    desc: "Curso dedicado à programação orientada a objetos em PHP, abordando classes, objetos, métodos, construtores e boas práticas. Capacitou para o desenvolvimento de aplicações backend organizadas, seguras e escaláveis, utilizadas em sistemas web e ERPs.",
  },

  {
    id: 9,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Firebase Fundamentals – The Net Ninja ",
    desc: "Formação nos fundamentos do Firebase, incluindo autenticação, Firestore, Realtime Database, hosting e integração com aplicações web. Desenvolveu competências para criar aplicações modernas com backend como serviço (BaaS), focadas em desempenho, segurança e escalabilidade.",
  },

  {
    id: 10,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "HTML & CSS 3 Series – Code With Mosh",
    desc: "Curso voltado para a construção de interfaces web modernas e responsivas, utilizando HTML5 e CSS. Abordou estruturação semântica, layouts responsivos, Flexbox, Grid e boas práticas de design, com foco em acessibilidade e experiência do usuário.",
  },

  {
    id: 11,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "JavaScript Fundamentals – Code With Mosh",
    desc: "Formação nos fundamentos de JavaScript, cobrindo variáveis, funções, estruturas de controlo, arrays, objetos e manipulação do DOM. Desenvolveu uma base sólida para a criação de aplicações web interativas e dinâmicas.",
  },

  {
    id: 12,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "JavaScript Advanced Topics – Code With Mosh",
    desc: "Curso avançado de JavaScript com foco em conceitos modernos como closures, protótipos, async/await, promises, módulos e padrões de design. Reforçou a capacidade de escrever código eficiente, escalável e preparado para aplicações web complexas.",
  },
  {
    id: 14,
    category: "experience",
    icon: <FaBriefcase />,
    year: "Janeiro 2019 – Fevereiro 2022",
    title: "Assistente de Comunicação e Imagem - TÉCNICA AGRO NEGÓCIO",
    desc: "Atuei na gestão da comunicação institucional e da imagem corporativa da empresa, contribuindo para o fortalecimento da marca e da presença digital. Fui responsável pela criação de conteúdos digitais, apoio em campanhas de marketing e gestão da presença online, alinhando a comunicação à estratégia digital da organização. Prestei suporte em ações promocionais e comunicação corporativa, garantindo consistência visual e eficácia na transmissão das mensagens institucionais.",
  },
  {
    id: 15,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Tailwind CSS – The Net Ninja",
    desc: "Formação em Tailwind CSS, focada na criação de interfaces modernas, responsivas e consistentes utilizando classes utilitárias. O curso reforçou boas práticas de UI, produtividade no desenvolvimento frontend e implementação rápida de layouts escaláveis para aplicações web.",
  },
  {
    id: 16,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Bootstrap – The Net Ninja",
    desc: "Curso voltado para o uso do framework Bootstrap na construção de interfaces responsivas e mobile-first. Abordou sistema de grid, componentes, utilitários e personalização, permitindo o desenvolvimento rápido de layouts profissionais e compatíveis com diferentes dispositivos.",
  },
  {
    id: 17,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Formação em Língua Inglesa - Wise Up Online",
    desc: "Formação em língua inglesa com foco em comunicação profissional, compreensão oral e escrita, vocabulário técnico e conversação aplicada ao contexto académico e corporativo. O curso contribuiu para o desenvolvimento da fluência, confiança na comunicação e capacidade de interagir em ambientes profissionais e tecnológicos em inglês.",
  },
  {
    id: 18,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2022",
    title: "Responsive Web Design – freeCodeCamp",
    desc: "Formação dedicada à criação de websites adaptáveis a diferentes dispositivos e tamanhos de tela. Incluiu estudos de HTML, CSS, Flexbox, Grid, design responsivo, media queries e boas práticas de acessibilidade, permitindo desenvolver interfaces modernas, funcionais e visualmente consistentes em qualquer plataforma.",
  },
];

export const skills = [
  {
    id: 1,
    title: "Html",
    percentage: "90",
  },

  {
    id: 2,
    title: "Css",
    percentage: "87",
  },

  {
    id: 3,
    title: "Javascript",
    percentage: "90",
  },

  {
    id: 4,
    title: "Git",
    percentage: "80",
  },

  {
    id: 5,
    title: "React.js",
    percentage: "85",
  },

  {
    id: 6,
    title: "Python",
    percentage: "50",
  },

  {
    id: 7,
    title: "Java",
    percentage: "70",
  },

  {
    id: 8,
    title: "Figma",
    percentage: "80",
  },

  {
    id: 9,
    title: "SQL Server",
    percentage: "80",
  },
  {
    id: 10,
    title: "MYSQL",
    percentage: "80",
  },
  {
    id: 11,
    title: "PostgreSQL",
    percentage: "80",
  },
  {
    id: 11,
    title: "UI/UX",
    percentage: "80",
  },
  {
    id: 12,
    title: "PHP",
    percentage: "80",
  },
  {
    id: 11,
    title: "Laravel",
    percentage: "80",
  },
];

export const portfolio = [
  {
    id: 1,
    title: "Projeto CASHUPPOS - CODE GENIUS LDA",
    img: cashuppos,
    details: [
      {
        icon: <FiFileText />,
        title: "Descrição : ",
        desc: "Sistema de ponto de venda e gestão de transações financeiras",
      },

      {
        icon: <FaCode />,
        title: "Linguagens : ",
        desc: "Java",
      },
      {
        icon: <FiExternalLink />,
        title: "Site : ",
        desc: "https://phierp.codegeniuslda.com",
      },
    ],
  },

  {
    id: 2,
    title: "Projeto SUPERTRACKING - CODE GENIUS LDA",
    img: track,
    details: [
      {
        icon: <FiFileText />,
        title: "Descrição : ",
        desc: "Sistema de rastreamento de encomendas e logística para empresas",
      },

      {
        icon: <FaCode />,
        title: "Linguagens : ",
        desc: "JavaScript | Node.js | React",
      },
      {
        icon: <FiExternalLink />,
        title: "Site : ",
        desc: "https://github.com/GutoAS/",
      },
    ],
  },

  {
    id: 3,
    title: "Projeto ONLINE STORE - CODE GENIUS LDA",
    img: gcorp,
    details: [
      {
        icon: <FiFileText />,
        title: "Descrição : ",
        desc: "Loja ecommerce",
      },
      {
        icon: <FaCode />,
        title: "Linguagens : ",
        desc: "PHP | Javascript",
      },
      {
        icon: <FiExternalLink />,
        title: "Site : ",
        desc: "https://gcorporationsales.store",
      },
    ],
  },

  {
    id: 5,
    title: "Portfolio Simulation",
    img: patrix,
    details: [
      {
        icon: <FiFileText />,
        title: "Descrição : ",
        desc: "Projecto individual",
      },
      {
        icon: <FiUser />,
        title: "Repositório : ",
        desc: "https://github.com/GutoAS/sass_project_patrix",
      },
      {
        icon: <FaCode />,
        title: "Linguagens : ",
        desc: "Html | Scss| Javascript ",
      },
      {
        icon: <FiExternalLink />,
        title: "Site : ",
        desc: "https://aspatrix.vercel.app/",
      },
    ],
  },
];

export const themes = [
  {
    id: 1,
    img: Theme1,
    color: "hsl(272.20338983050846, 73.44398340248962%, 47.25490196078431%)",
  },

  {
    id: 2,
    img: Theme2,
    color: "hsl(0, 100%, 50%)",
  },

  {
    id: 3,
    img: Theme3,
    color: "hsl(271, 76%, 53%)",
  },

  {
    id: 4,
    img: Theme4,
    color: "hsl(210, 100%, 50%)",
  },

  {
    id: 5,
    img: Theme5,
    color: "hsl(43, 74%, 49%)",
  },

  {
    id: 6,
    img: Theme6,
    color: "hsl(328.95652173913044, 93.4959349593496%, 51.76470588235295%)",
  },

  {
    id: 7,
    img: Theme7,
    color: "hsl(79.88950276243094, 89.16256157635469%, 39.80392156862745%)",
  },

  {
    id: 8,
    img: Theme8,
    color: "hsl(29, 100%, 50%)",
  },

  {
    id: 9,
    img: Theme9,
    color: "hsl(113.04878048780489, 98.79518072289157%, 32.549019607843135%)",
  },

  {
    id: 10,
    img: Theme10,
    color: "hsl(42, 100%, 50%)",
  },
];

export const socials = [
  {
    id: 1,
    socialMedia: "Linkedin",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/in/agostinhosoberano",
  },
  {
    id: 2,
    socialMedia: "WhatsApp",
    icon: <FaWhatsapp />,
    link: "https://api.whatsapp.com/send?phone=258842991006",
  },
  {
    id: 3,
    socialMedia: "Discord",
    icon: <FaDiscord />,
    link: "#",
  },
  {
    id: 4,
    socialMedia: "Gmail",
    icon: <FaEnvelope />,
    link: "https://mail.google.com/mail/?view=cm&to=soberanoagostinho@gmail.com",
  },
  {
    id: 5,
    socialMedia: "Instagram",
    icon: <FaInstagram />,
    link: "https://www.instagram.com/agostinho_soberano/",
  },
  {
    id: 6,
    socialMedia: "Github",
    icon: <FaGithub />,
    link: "https://github.com/GutoAS",
  },
];
